import { getDefaultStore, useAtomValue } from 'jotai';
import { atomWithReset } from 'jotai/utils';

type LaunchStatus = 'idle' | 'started' | 'completed' | 'failed';

export interface StoreNameData {
  isAcceptedPayments: boolean;
  selectedSuggestion: string;
  suggestions: string[];
  isLoadingSuggestions: boolean;
  isLoadingAggregators: boolean;
  launchStatus: LaunchStatus;
  currentStoreName: string;
  isShowAcceptPayments: boolean;
}

const defaultStoreNameData: StoreNameData = {
  isAcceptedPayments: true,
  selectedSuggestion: '',
  suggestions: [],
  isLoadingSuggestions: false,
  isLoadingAggregators: false,
  launchStatus: 'idle',
  currentStoreName: '',
  isShowAcceptPayments: true,
};

export const StoreNameDataAtom = atomWithReset<StoreNameData>(defaultStoreNameData);

export const useStoreNameData = () => {
  return useAtomValue(StoreNameDataAtom);
};

export const setStoreNameData = (partialData: Partial<StoreNameData>) => {
  const store = getDefaultStore();
  store.set(StoreNameDataAtom, (prev) => ({
    ...prev,
    ...partialData,
  }));
};

export const setIsLoadingSuggestions = (isLoading: boolean) => {
  setStoreNameData({ isLoadingSuggestions: isLoading });
};

export const setIsLoadingAggregators = (isLoading: boolean) => {
  setStoreNameData({ isLoadingAggregators: isLoading });
};

export const setStoreNameSuggestions = (suggestions: string[]) => {
  setStoreNameData({ suggestions });
};

export const resetStoreNameData = () => {
  const store = getDefaultStore();
  store.set(StoreNameDataAtom, defaultStoreNameData);
};
